<template>
<div class="bg-gray-700 px-4 pt-5 pb-4 sm:pb-4">
    <form @submit.prevent="createNewTour">
        <div class="mt-3 text-center sm:mt-0 sm:text-left">
            <h4 class="text-white text-sm font-bold uppercase mb-3">Add Tour</h4>
            <tour-name v-if="actualForm == 'tour-name'" />
            <tour-location v-if="actualForm == 'tour-location'" />
            <span v-if="errors" class="errormessage">{{ errors }}</span>

        </div>
    </form>
</div>
<div class="bg-gray-700 px-4 py-3 sm:px-6 flex justify-center">
    <button @click="toggleModalOrGetBack" type="button" class="btn btn-black mx-2">
      {{actualForm != 'tour-name' ? 'Back' : 'Cancel'}}
    </button>
    <button v-if="!form.processing" type="button" @click="setActualForm" class="btn btn-gradient mx-4">
        <i v-if="actualForm == 'tour-location'" class="save mr-1"></i>
        {{actualForm == 'tour-location' ? 'Save Tour': 'Next'}}
    </button>
    <button v-if="form.processing" class="btn btn-gradient mx-4"><Spinner/></button>
  </div>
</template>

<script>

import TourName from './CreateTourFormParts/TourName'
import TourLocation from './CreateTourFormParts/TourLocation'
//import TourProvider from './CreateTourFormParts/TourProvider'
import Spinner from '@/UI/Spinner'
export default {
    components: {
        TourName,
        TourLocation,
        Spinner
    },
    props: ['toggleModal'],
    data() {
        return {
            actualForm: 'tour-name',
            form: this.$inertia.form({
                _method: 'POST',
                newTourData: null,
            }),
            errors: null
        }
    },
    methods: {
        createNewTour(btn) {
            ///pass data to the form
            this.form.newTourData = this.$page.props.newTourData;
            ///send form to backend
            this.form.post(route('tour.store', this.$page.props.newTourData.selectedProvider.identifier), {
                errorBag: 'createNewTour',
                preserveScroll: true,
                onSuccess: (data) => {
                    this.actualForm = 'tour-name';
                    this.$page.props.newTourData == {};
                    this.toggleModal(false);
                    btn.disabled = false;
                    btn.innerHTML = 'Save Tour';
                }
            });
        },
        setActualForm(e){
            this.errors = null;
            //==verification if tourName present
            if(!this.$page.props.newTourData.dynamicTourName){
                this.errors = 'Tour name does not exist';
                return;
            }
            const unFilledNames = this.$page.props.newTourData.dynamicTourName.filter(el => el.show == true).filter(el => el.value.length == 0);
            if(unFilledNames.length > 0){
                this.errors = 'Tour name does not exist';
                return
            }
            //==verification if tourName present

            if(this.actualForm == 'tour-name'){
                this.actualForm = 'tour-location'
                return;
            }

            //==verification if location present
            if(!this.$page.props.newTourData.location){
                this.errors = 'Location does not exist';
                return;
            }
            if(this.$page.props.newTourData.location.latitude.length == 0){
                this.errors = 'Latitude does not exist';
                return;
            }
            if(this.$page.props.newTourData.location.longitude.length == 0){
                this.errors = 'Longitude does not exist';
                return;
            }
            //==verification if location present

            //==verification if location correct
            if(this.$page.props.newTourData.location.latitude < -90){
                this.errors = 'The latitude must be at least -90';
                return;
            }
            if(this.$page.props.newTourData.location.latitude > 90){
                this.errors = 'The latitude may not be greater than 90';
                return;
            }
            if(this.$page.props.newTourData.location.longitude < -180){
                this.errors = 'The longitude must be at least -180';
                return;
            }
            if(this.$page.props.newTourData.location.longitude > 180){
                this.errors = 'The longitude may not be greater than 180';
                return;
            }
            //==verification if location correct

            //==verification if provider present
            if(!this.$page.props.newTourData.selectedProvider ||
            this.$page.props.newTourData.selectedProvider.length == 0)
            {
                console.log('Provider is not selected');
                return;
            }
            //==verification if provider present

            if(this.actualForm == 'tour-location'){
                e.target.disabled = true;
                e.target.innerHTML = 'Loading...';
                this.createNewTour(e.target);
                return;
            }
        },
        toggleModalOrGetBack() {
            if(this.actualForm != 'tour-name'){
                this.getBack(this.actualForm)
            } else {
                this.toggleModal(false)
            }
        },
        getBack() {
            if(this.actualForm == 'tour-subtitle'){
                this.actualForm = 'tour-name'
                return;
            }
            if(this.actualForm == 'tour-location'){
                this.actualForm = 'tour-name'
                return;
            }
            if(this.actualForm == 'tour-provider'){
                this.actualForm = 'tour-location'
                return;
            }
        }
    },
}
</script>
